export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_END = 'LOGOUT_END';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
